import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { Button, Col, ListGroup } from 'react-bootstrap';
import {
  makeGetToken,
  makeGetListAccount,
  makeGetDefaultAccount,
  makeGetMarginList,
  makeGetAuth,
} from '../../lib/selector';

import {
  setAuth,
  setDblPrice,
  setLogin,
  setToast,
} from '../../containers/client/actions';
import { numberFormat, _formatDate2 } from '../../utils';

import { v4 as uuidv4 } from 'uuid';
import { WebSocketContext } from '../../containers/socket/webSocket';

import { translate } from 'react-i18next';

import { takeRight, take, isEqual } from 'lodash';

class MarginList extends React.Component {
  state = {
    continued: false,
    totalCount: 0,
    page: 1,
    contentShow: [],
    _totalPage: 1,
  };

  componentDidMount() {
    const { defaultAccount } = this.props;
  }

  componentDidUpdate(preProps) {
    const { defaultAccount, marginList } = this.props;

    if (marginList && marginList !== preProps.marginList) {
      this.handleQueryPage(1);
    }
  }

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: this.props.t('txt-notice'),
    };
    this.props.dispatch(setToast(toastMsg));
  };

  _handleNextPage = (step) => {
    const { page } = this.state;
    this.handleQueryPage(page + step);
  };

  handleQueryPage = (page) => {
    const { marginList } = this.props;
    if (!marginList || !marginList.list.length) return;
    const _pageSize = 15;
    const _totalPage =
      marginList.list.length > 0
        ? Math.ceil(marginList.list.length / _pageSize)
        : 1;

    const _takeContent = take(marginList.list, _pageSize * page);
    const _contentShow = takeRight(
      _takeContent,
      _takeContent.length - _pageSize * (page - 1)
    );
    // console.log(_contentShow);
    this.setState({
      contentShow: _contentShow,
      page,
      continued: page < _totalPage,
      _totalPage,
    });
  };

  _handleAuthen = () => {
    this.props.dispatch(setAuth());
  };

  _handleTradeAction = (type, symbol) => {
    const { auth, token } = this.props;

    if (!token) {
      this.props.dispatch(setLogin());
      return false;
    }

    if (!auth || !auth.isVerified) {
      this.props.dispatch(setAuth());
      return false;
    }

    const newOrder = {
      symbol: symbol,
      side: type,
      price: '',
    };
    console.log('Trade Symbol', newOrder);
    this.props.dispatch(setDblPrice(newOrder));
  };

  render() {
    const { marginList, auth, t } = this.props;
    console.log('marginList', marginList);
    const { page, continued, _totalPage, contentShow } = this.state;

    return (
      <Fragment>
        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
          <span
            className="mr-auto ml-2 text-white"
            style={{ fontSize: '18px' }}
          >
            {`${t('txt-label-margin-list')}`}
          </span>
          {/* <FormMarginList /> */}
        </div>
        <div className="d-flex flex-column m-2">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center">{t('txt-stock')}</th>
                <th className="text-center">{t('txt-info')}</th>
                <th className="text-center">{t('txt-max-margin-rate')}</th>
                <th className="text-center">{t('txt-actions')}</th>
              </tr>
            </thead>
            <tbody>
              {contentShow &&
                !!contentShow.length &&
                contentShow.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">{item.symbol}</td>
                      <td className="text-left">{item.acntGrp}</td>
                      <td className="text-center">
                        {numberFormat((1 - item.marginRt) * 100, 2, '0')}%
                      </td>
                      <td className="text-center">
                        {auth && auth.isVerified ? (
                          <Fragment>
                            <button
                              className="btn fz-14 text-uppercase trade_side_1 cursor-pointer pr-2 pl-2 pt-0 pb-0"
                              onClick={() =>
                                this._handleTradeAction('BUY', item.symbol)
                              }
                            >
                              {t('txt-buy')}
                            </button>
                            <button
                              className="btn fz-14 text-uppercase trade_side_2 cursor-pointer pr-2 pl-2 pt-0 pb-0 ml-2"
                              onClick={() =>
                                this._handleTradeAction('SELL', item.symbol)
                              }
                            >
                              {t('txt-sell')}
                            </button>
                          </Fragment>
                        ) : (
                          <Button
                            variant="warning"
                            className="fz-10"
                            style={{ height: '20px', padding: '0 15px' }}
                            onClick={() => this._handleAuthen()}
                          >
                            {t('txt-xacthuc')}
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {(!marginList || !marginList.list.length) && (
            <p className="text-center fz-14 mt-2 title-time">
              {t('txt-no-data-found')}
            </p>
          )}
          {marginList && (
            <div className="d-flex flex-row-reverse align-items-center paging mt-2">
              <div className="d-flex align-items-center">
                <Button
                  onClick={() => this._handleNextPage(-1)}
                  disabled={page === 1}
                  className="d-flex align-items-center justify-content-center"
                >
                  {'<'}
                </Button>
                <Button
                  onClick={() => this._handleNextPage(1)}
                  disabled={!continued}
                  className="d-flex align-items-center justify-content-center"
                >
                  {'>'}
                </Button>
              </div>
              <span className="fz-14 text-white mr-2">{`${t(
                'txt-label-page'
              )} ${page + '/' + _totalPage}`}</span>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

MarginList.contextType = WebSocketContext;

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  const getListAccount = makeGetListAccount();
  const getDefaultAccount = makeGetDefaultAccount();

  const getMarginList = makeGetMarginList();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      auth: getAuth(state),
      listAccount: getListAccount(state),
      defaultAccount: getDefaultAccount(state),

      marginList: getMarginList(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(MarginList)
);
